export default "__VITE_PUBLIC_ASSET__3f91ba78__"